import React, { useEffect, useState } from "react";


import './App.css';
import { AdPage } from './components/AdPage'

interface AppProps {
    category: string;
}


function App(props: AppProps) {


    return (
        <div className="App" >
            <header className="App-header">
            </header>
            <AdPage />
        </div>
    );
}

export default App;
